import styled from 'styled-components'

// eslint-disable-next-line import/prefer-default-export
export const ContentSkeletonsWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`
